import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Mail } from 'app/models/mail';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UPTOPResponse } from 'app/models/uptop';

@Injectable()
export class MailService {

  private apiUrl = environment.api.url + environment.api.mail.url;

  constructor(private http: HttpClient) {}

  sendMail(id: string, mail: Mail, sendType: string): Observable<UPTOPResponse> {
    return this.http
      .post<UPTOPResponse>(this.apiUrl,
        { assetId: id, mail: mail },
        { params: { sendType: sendType }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mail.service.ts